var _desc, _defs, _rect, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDevopslive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "DevopsLive Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "Rounded tile with a gear and a live heartbeat line for continuous delivery/observability.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gdo",
    x1: 64,
    y1: 96,
    x2: 448,
    y2: 416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F2937"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pulse",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#34D399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60A5FA"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 32,
    width: 448,
    height: 448,
    rx: 96,
    fill: "url(#gdo)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(180 188)",
    fill: "none",
    stroke: "#F3F4F6",
    strokeWidth: 18,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 76,
    r: 44
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 -8v32M76 128v32M-8 76h32M128 76h32M14 14l23 23M115 115l23 23M115 37l23-23M14 138l23-23"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72 336h90l16-28 18 48 24-44 14 24h206",
    fill: "none",
    stroke: "url(#pulse)",
    strokeWidth: 14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevopslive);
export default __webpack_public_path__ + "static/media/devopslive.512237ff7d95e2c0c2b6120187813488.svg";
export { ForwardRef as ReactComponent };